import { putTreeNode, removeTreeNode, updateTree } from "@/utils/treeUtils"
import { deepClone } from "@/utils"

export default {
	selectNode(state, { nodeIdToSelect = "" }) {
		state.selectedNodeIds = [nodeIdToSelect]
	},

	hoverNode(state, { nodeIdToHover = "" }) {
		state.hoveredNodeId = nodeIdToHover
	},

	toggleExpandNode(state, { nodeIdToExpand = "" }) {
		// If node is already expanded, remove it, otherwise add to the array
		if (state?.expandedNodeIds?.includes(nodeIdToExpand))
			state.expandedNodeIds = state.expandedNodeIds.filter(expandedNodeId => expandedNodeId !== nodeIdToExpand)
		else state.expandedNodeIds.push(nodeIdToExpand)
	},

	expandAllNodes(state) {
		const selectedComponent = state?.app?.components?.find(item => item.id === state.selectedComponentId)

		// Collect all nodeIds and put them into state.expandedNodeIds
		const nodeIdsToExpand = []

		updateTree({
			tree: selectedComponent?.editorAst ?? [],
			updateFunction: node => nodeIdsToExpand.push(node.id)
		})
		state.expandedNodeIds = nodeIdsToExpand
	},

	putNode(state, node) {
		const selectedComponent = state?.app?.components?.find(item => item?.id === state?.selectedComponentId) ?? {}
		selectedComponent.editorAst = putTreeNode({ tree: selectedComponent?.editorAst ?? [], payload: deepClone(node) })
	},

	deleteNode(state, { nodeToDelete = {} }) {
		const selectedComponent = state?.app?.components?.find(item => item?.id === state?.selectedComponentId) ?? {}
		selectedComponent.editorAst = removeTreeNode({ tree: selectedComponent?.editorAst ?? [], nodeId: nodeToDelete?.id })
	},

	setApp(state, payload) {
		state.app = payload
	},

	patchApp(state, payload) {
		state.app = { ...state.app, ...payload }
	},

	setCanvasComponents(state, payload) {
		state.canvas.components = payload
	},

	selectComponent(state, componentId) {
		state.selectedComponentId = componentId
	},

	putComponent(state, componentToPut) {
		state.apps.components = state.apps?.components?.map(component =>
			component.id === componentToPut.id ? { ...componentToPut } : component
		)
	},

	patchComponent(state, { componentId, property, value }) {
		state.app.components = state.app?.components?.map(component => {
			if (component.id === componentId) return { ...component, [property]: value }
			return component
		})
	},

	deleteComponent(state, componentId) {
		if (!state.app.components) state.app.components = []
		state.app.components = state.app.components.filter(item => item.id !== componentId)
	},

	createComponent(state, payload) {
		if (!state.app.components) state.app.components = []
		state.app.components.push(payload)
	}
}
